<template>
  <div class="checkAll">
    <el-tree v-if="selectIds"
             :data="data"
             show-checkbox
             node-key="id"
             :default-checked-keys="selectIds"
             :props="defaultProps"
             @check="currentChecked">
    </el-tree>
  </div>
</template>
<script>
export default {
  props: {
    ChackAll: {
      type: Array,
    }
  },
  data () {
    return {
      data: [
        {
          id: 1,
          name: '所有广告系列',
          children: [],
        },
      ],
      selectIds: null,
      defaultProps: {
        children: 'children',
        label: 'name',
      },
    };
  },
  watch: {
    ChackAll: {
      handler (val) {
        if(val.length){
          this.getChackAll(val)
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    //获取全选列表数据
    async getChackAll (val) {
      this.data[0].children = val || [];
        this.selectIds = val.map(item => {
          return item.id;
        });
    },
    currentChecked (nodeObj, SelectedObj) {
      if (SelectedObj.checkedNodes.length) {
        SelectedObj.checkedNodes[0].children
          ? this.$emit('input', SelectedObj.checkedNodes[0].children)
          : this.$emit('input', SelectedObj.checkedNodes);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.checkAll {
	border: 1px solid #dcdfe6;
	border-radius: 4px;
}
</style>
